<template>
  <div v-if="isSuccessRegister">
    <h5>{{ translations[13898] }}</h5>
    <p v-if="getPasswordRegister">
      {{ translations[10809] }}
    </p>
    <p v-else>
      {{ translations[13899] }}
    </p>
    <p>
      {{ translations[13932] }}
      <a class="fw-bolder" href="#" @click.prevent="reloadTab">
        {{ translations[13933] }}
      </a>
    </p>
  </div>
  <b-form ref="registerForm" v-else autocomplete="new-password" @keydown="handleKeydown">
    <b-alert :show="isErrorsRegister" variant="danger">
      <span v-if="isUsernameExist">{{ translations[232] }}</span>
      <span v-if="isEmailExist">{{ translations[10870] }}</span>
      <span v-if="isPrivacyError">{{ translations[14435] }}</span>
    </b-alert>
    <b-alert :show="isRecaptchaError" variant="danger"> Please confirm the captcha. </b-alert>
    <b-alert :show="isErrorsRegisterPassword" variant="danger">
      {{ translations[240] }}
    </b-alert>
    <b-form-group v-if="!isAbatestSid" class="mb-1" id="input-group-1" label-for="applicant-username">
      <b-form-input
        size="lg"
        class="border-0"
        id="applicant-username"
        v-model="register.username"
        type="text"
        autocomplete="new-password"
        :placeholder="translations[11001]"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group class="mb-1" id="input-group-2" label-for="applicant-email">
      <b-form-input
        size="lg"
        class="border-0"
        id="applicant-email"
        v-model="register.email"
        type="email"
        autocomplete="new-password"
        :placeholder="translations[5549]"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group v-if="isApplicantField(typeField.visible,'firstname')" class="mb-1" id="input-group-3" label-for="applicant-firstname-register">
      <b-form-input
        size="lg"
        class="border-0"
        id="applicant-firstname-register"
        v-model="register.firstname"
        type="text"
        :placeholder="translations[234]"
        :required="isApplicantField(typeField.mandatory, 'firstname')"
      ></b-form-input>
    </b-form-group>
    <b-form-group v-if="isApplicantField(typeField.visible,'lastname')" class="mb-1" id="input-group-4" label-for="applicant-lastname-register">
      <b-form-input
        size="lg"
        class="border-0"
        id="applicant-lastname-register"
        v-model="register.lastname"
        type="text"
        :placeholder="translations[235]"
        :required="isApplicantField(typeField.mandatory, 'lastname')"
      ></b-form-input>
    </b-form-group>
    <b-form-group v-if="isApplicantField(typeField.visible, regField.birthdate)" class="mb-1" id="input-group-5">
      <label class="d-block d-block mb-0 mt-1 pl-1">
        {{ translations[1724] }}
      </label>
      <div class="d-flex">
        <b-form-select v-model="bDay" :options="daysList" class="border-0 form-control form-control-lg flex-fill mr-1" :class="{ 'is-invalid': isBirthdateError }"></b-form-select>
        <b-form-select v-model="bMonth" :options="months" class="border-0 form-control form-control-lg flex-fill mr-1" :class="{ 'is-invalid': isBirthdateError }"></b-form-select>
        <b-form-select v-model="bYear" :options="yearsList" class="border-0 form-control form-control-lg flex-fill" :class="{ 'is-invalid': isBirthdateError }"></b-form-select>
      </div>
      <div v-if="isBirthdateError" class="text-danger mt-1 pl-1">{{ translations[15489] }}</div>
    </b-form-group>
    <b-form-group v-if="isApplicantField(typeField.visible, regField.citizenship)" class="mb-1" id="input-group-6">
      <multiselect
        v-model="citizenshipSelected"
        :options="citizenshipOptions"
        :multiple="false"
        label="name"
        track-by="value"
        :placeholder="translations[13287]"
        :showLabels="false"
        :class="{ 'is-invalid': isCitizenshipError }"
      />
      <div v-if="isCitizenshipError" class="text-danger mt-1">{{ translations[15489] }}</div>
    </b-form-group>
    <b-form-group v-if="isApplicantField(typeField.visible, 'stay_state') && !isEUZone" class="mb-1 pl-1" id="input-group-stay-state">
      <b-form-checkbox v-model="stayState" :value="1" :unchecked-value="0" switch>
        <p class="fs-6 mb-0">{{ translations[13286] }}</p>
      </b-form-checkbox>
    </b-form-group>
    <b-input-group v-if="isShowPasswordRegister" class="mb-1" id="input-group-register" label-for="applicant-password-register">
      <PasswordPattern size="lg"
                       class-widget="border-0"
                       id="applicant-password-register"
                       v-model.trim="register.password"
                       :field-type="passwordFieldType"
                       :placeholder="translations[10948]"
                       :title-widget="translations[2521]"/>
      <b-input-group-append>
        <b-button variant="custom-light"  @click="togglePasswordVisibility">
          <b-icon :icon="passwordFieldIcon"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-input-group class="mb-1" v-if="isShowPasswordRegister" id="input-group-register2" label-for="applicant-password-register2">
      <PasswordPattern size="lg"
                       class-widget="border-0"
                       id="applicant-password-register2"
                       v-model.trim="register.password_repeat"
                       :field-type="passwordRepeatFieldType"
                       :placeholder="translations[236]"
                       :title-widget="translations[2521]"/>

      <b-input-group-append>
        <b-button variant="custom-light"  @click="togglePasswordRepeatVisibility">
          <b-icon :icon="passwordRepeatFieldIcon"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-row align-v="center" v-if="isOnlyAbaSids">
      <b-col cols="auto">
        <p v-html="translations[15534]" class="fs-6 mb-0"></p>
        <b-form-group class="mb-2" id="input-group-3" label-for="applicant-checkbox">
          <b-form-checkbox id="applicant-checkbox" v-model="marketingConsent" name="check-button" switch>
            <p class="fs-6 mb-0">{{ translations[15536] }}</p>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-v="center" v-else>
      <b-col cols="auto">
        <b-form-group class="mb-2" id="input-group-3" label-for="applicant-checkbox">
          <b-form-checkbox id="applicant-checkbox" v-model="isRegisterCheckbox" name="check-button" switch>
            <p v-html="translations[14016]" class="fs-6 mb-0"></p>
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group class="mb-1 mt-2"  v-if="isApplicantField(typeField.visible, regField.captcha)">
      <Captcha ref="captcha" @change="updateCaptchaToken" />
    </b-form-group>
  </b-form>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { mixins } from 'vue-class-component';
import RegistrationFieldsMixin from '@/mixins/RegistrationFieldsMixin';
import { TypeField, RegistrationField } from '@/types/Login';
import Captcha from '@/components/Widget/Captcha.vue';
import PasswordPattern from '@/components/Widget/PasswordPattern.vue';
import Multiselect from 'vue-multiselect';
import { checkRegistrationEvent } from '@/api/Auth';

@Component({
  components: {
    Captcha,
    PasswordPattern,
    Multiselect,
  },
})
export default class RegisterApplicantForm extends mixins(RegistrationFieldsMixin) {
  isPasswordVisible = false;

  isPasswordRepeatVisible = false;

  isErrorsRegisterPassword = false;

  isSuccessRegister = false;

  isPrivacyError = false;

  isBirthdateError = false;

  isCitizenshipError = false;

  citizenshipSelected: any = null;

  stayState = 0;

  bDay = 0;

  bMonth = 0;

  bYear = 0;

  get translations() {
    return AppModule.translation;
  }

  get sid() {
    return AppModule.sid;
  }

  get lang() {
    return AppModule.language;
  }

  // Email login is driven solely by the partner setting (applicant_login_by_email).
  get isAbatestSid() {
    return !!AppModule.setting?.applicant_login_by_email;
  }

  isRegisterCheckbox = false;

  marketingConsent = false;

  get isErrorsRegister() {
    return this.isUsernameExist || this.isEmailExist || this.isPrivacyError;
  }

  get getPasswordRegister() {
    return AppModule.setting?.registration_with_password;
  }

  get passwordFieldType() {
    return this.isPasswordVisible ? 'text' : 'password';
  }

  get passwordFieldIcon() {
    return this.isPasswordVisible ? 'eye-slash' : 'eye';
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  get passwordRepeatFieldType() {
    return this.isPasswordRepeatVisible ? 'text' : 'password';
  }

  get passwordRepeatFieldIcon() {
    return this.isPasswordRepeatVisible ? 'eye-slash' : 'eye';
  }

  togglePasswordRepeatVisibility() {
    this.isPasswordRepeatVisible = !this.isPasswordRepeatVisible;
  }

  @Watch('isRegisterCheckbox')
  handler(val: boolean) {
    if (val) this.isPrivacyError = false;
  }

  @Watch('register.password')
  handlerPassword(val: boolean) {
    if (val) this.isErrorsRegisterPassword = false;
  }

  @Watch('register.password_repeat')
  handlerPasswordRepeat(val: boolean) {
    if (val) this.isErrorsRegisterPassword = false;
  }

  @Watch('register.email')
  handleRegisterEmailChange(val: string) {
    if (!this.isAbatestSid) return;
    // For abatest we keep username hidden and derive it from email local-part.
    this.register.username = this.extractUsernameFromEmail(val);
  }

  get isEUZone() {
    const euZoneCountries = [
      'BE', 'BG', 'DK', 'DE', 'EE', 'FI', 'FR', 'GR', 'IE', 'IT',
      'HR', 'LV', 'LT', 'LU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO',
      'SE', 'SK', 'SI', 'ES', 'CZ', 'HU', 'CY', 'NO', 'IS', 'LI',
    ];
    return euZoneCountries.includes(this.citizenshipSelected?.value || '');
  }

  get citizenshipField() {
    return this.applicantRegistrationFields.find((f: any) => f.name === RegistrationField.citizenship);
  }

  get citizenshipOptions() {
    return this.citizenshipField?.options || [];
  }

  @Watch('citizenshipSelected')
  onCitizenshipChange(val: any) {
    if (val) this.isCitizenshipError = false;
  }

  @Watch('bDay')
  onBirthDayChange() {
    if (this.bDay) this.isBirthdateError = false;
  }

  @Watch('bMonth')
  onBirthMonthChange() {
    if (this.bDay >= this.daysInMonth) this.bDay = 0;
    if (this.bMonth) this.isBirthdateError = false;
  }

  @Watch('bYear')
  onBirthYearChange() {
    if (this.bDay >= this.daysInMonth) this.bDay = 0;
    if (this.bYear) this.isBirthdateError = false;
  }

  get months() {
    return [
      { value: 0, text: this.translations[3547] },
      { value: 1, text: this.translations[1712] },
      { value: 2, text: this.translations[1713] },
      { value: 3, text: this.translations[1714] },
      { value: 4, text: this.translations[1715] },
      { value: 5, text: this.translations[1716] },
      { value: 6, text: this.translations[1717] },
      { value: 7, text: this.translations[1718] },
      { value: 8, text: this.translations[1719] },
      { value: 9, text: this.translations[1720] },
      { value: 10, text: this.translations[1721] },
      { value: 11, text: this.translations[1722] },
      { value: 12, text: this.translations[1723] },
    ];
  }

  get daysInMonth() {
    if (this.bMonth === 2) {
      const isLeap = this.bYear % 400 === 0 || (this.bYear % 4 === 0 && this.bYear % 100 !== 0);
      return isLeap ? 30 : 29;
    }
    return [4, 6, 9, 11].includes(this.bMonth) ? 31 : 32;
  }

  get daysList() {
    const days = [{ value: 0, text: this.translations[3545] }];
    for (let i = 1; i < this.daysInMonth; i += 1) {
      days.push({ value: i, text: String(i) });
    }
    return days;
  }

  get yearsList() {
    const currentYear = new Date().getFullYear();
    const years = [{ value: 0, text: this.translations[3548] }];
    for (let i = 1940; i < currentYear; i += 1) {
      years.push({ value: i, text: String(i) });
    }
    return years;
  }

  isEmailExist = false;

  isUsernameExist = false;

  register = {
    username: '',
    password: '',
    password_repeat: '',
    email: '',
    sid: this.sid,
    lang: this.lang,
    firstname: '',
    lastname: '',
    captcha: '',
    registration_event: '',
  } as any;

  get isShowPasswordRegister() {
    return AppModule.setting?.registration_with_password;
  }

  get getRegisterEvent() {
    return String(this.$route.query?.event || '');
  }

  reloadTab() {
    this.$bvModal.hide('register-modal');
    this.$bvModal.show('login-modal');
  }

  resetErrors() {
    this.isPrivacyError = false;
    this.isBirthdateError = false;
    this.isCitizenshipError = false;
    this.isEmailExist = false;
    this.isUsernameExist = false;
    this.isRecaptchaError = false;
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.$emit('submit');
    }
  }

  updateCaptchaToken(payload: string) {
    this.register.captcha = payload;
    this.isRecaptchaError = false;
  }

  extractUsernameFromEmail(email: string) {
    const normalizedEmail = String(email || '').trim();
    if (!normalizedEmail) return '';
    const [localPart = ''] = normalizedEmail.split('@');
    return localPart.trim();
  }

  async onLogin() {
    try {
      const login = {
        username: this.register.username,
        password: this.register.password,
        sid: this.sid,
      };
      await UserModule.LoginApplicant(login);
      await this.$router.push({
        name: 'Cabinet',
        query: {
          lang: this.lang,
          ...(UserModule.openAgentPageOnCabinet && { agent: '1' }),
        },
      });
    } catch (error: any) {
      console.error(error);
    }
  }

  async onRegistration() {
    const form = this.$refs.registerForm as HTMLFormElement;
    if (!form.reportValidity()) {
      return;
    }

    this.resetErrors();

    if (!this.isOnlyAbaSids && !this.isRegisterCheckbox) {
      this.isPrivacyError = true;
      return;
    }

    if (this.isApplicantField(TypeField.mandatory, RegistrationField.birthdate) && (!this.bYear || !this.bMonth || !this.bDay)) {
      this.isBirthdateError = true;
      return;
    }

    if (this.isApplicantField(TypeField.mandatory, RegistrationField.citizenship) && !this.citizenshipSelected) {
      this.isCitizenshipError = true;
      return;
    }

    try {
      // Safety net: ensure username is always derived for abatest before request.
      if (this.isAbatestSid) {
        this.register.username = this.extractUsernameFromEmail(this.register.email);
      }

      const applicantOptionalFields = ['firstname', 'lastname', 'captcha'];

      applicantOptionalFields.forEach((field) => {
        if (!this.isApplicantField(TypeField.visible, field)) {
          delete this.register[field];
        }
      });

      if (!this.isShowPasswordRegister) {
        delete this.register.password;
        delete this.register.password_repeat;
      } else if (this.register.password !== this.register.password_repeat) {
        this.isErrorsRegisterPassword = true;
        return;
      }

      const isEventValid = await this.onCheckRegistrationEvent();
      if (!isEventValid) {
        delete this.register.registration_event;
      }
      const data = { ...this.register };
      if (this.isOnlyAbaSids) {
        data.marketing_consent = this.marketingConsent;
      }
      if (this.isApplicantField(TypeField.visible, RegistrationField.birthdate) && this.bYear && this.bMonth && this.bDay) {
        data.birthdate = `${this.bYear}-${this.bMonth}-${this.bDay}`;
      }
      if (this.isApplicantField(TypeField.visible, RegistrationField.citizenship) && this.citizenshipSelected) {
        data.citizenship = this.citizenshipSelected.value;
      }
      if (this.isApplicantField(TypeField.visible, 'stay_state') && !this.isEUZone) {
        data.stay_state = this.stayState;
      }
      await UserModule.RegisterApplicant(data).then((response: any) => {
        if (response.autolog) {
          this.onLogin();
        } else {
          this.isSuccessRegister = true;
        }
      });
    } catch (error: any) {
      if (error.response.data.message === 'email already exists') this.isUsernameExist = true;
      if (error.response.data.message === 'username already exists') this.isUsernameExist = true;
      if (error.response.data.message === 'invalid params') this.isUsernameExist = true;
      if (error.response.data.message === 'Captcha not solved') {
        this.isRecaptchaError = true;
        (this.$refs as any).captcha.resetCaptcha();
      }
    }
  }

  async onCheckRegistrationEvent(): Promise<boolean> {
    const event = this.getRegisterEvent;

    if (!event) return false;

    const { exists } = await checkRegistrationEvent({
      sid: this.sid,
      name: event,
      user_type: 1, // applicant
    });

    if (exists) {
      this.register.registration_event = event;
    }

    return exists;
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
::v-deep .multiselect__tags {
  padding: 8px 40px 0 16px;
}

::v-deep .multiselect .multiselect__placeholder {
  color: #6c757d;
}
</style>
